import { render, staticRenderFns } from "./AllItsuLocationsSectionModule.vue?vue&type=template&id=64bf97c9&"
import script from "./AllItsuLocationsSectionModule.vue?vue&type=script&lang=js&"
export * from "./AllItsuLocationsSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports